import Vue from 'vue'
import Vuex from 'vuex'

// 使用vuex
Vue.use(Vuex)

// 创建实例
const store = new Vuex.Store({

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js